import { Translator } from '@/types/translator.type';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useTranslatedConst = () => {
  const { t } = useTranslation();

  const getTranslatedConst = useCallback(
    <T,>(constant: (t: Translator) => T) => constant(t),
    [t],
  );

  return getTranslatedConst;
};
